<template lang="pug">
    v-container
        v-card-text
            .subheading.font-weight-medium.text-xs-center Código Único Supervisor:
        v-card-actions
            v-layout(row justify-center)   
                v-flex(xs4)
                    v-text-field.display-1.font-weight-medium(outline font-size=20 solo color="red"
                    mask="A###########"
                    type="password"
                    v-model="key"
                    :rules="[rules.counter]" validate-on-blur
                    @input="setUniqueKey(key)"
                    @keyup.enter = "checkKey"
                    @keydown.esc="$emit('exit')"
                    ref="auth-field"
                    )
        v-divider
</template>

<script>
import {mapState, mapActions, mapGetters} from 'vuex'
export default {
    name: 'supervisor-unique-key',
    props: {},
    data: function(){
        return {
            key: ""
        }
    },
    computed: {
        ...mapGetters('UniqueKeyModule', {
            rules: 'rules',
            uniqueKey: 'uniqueKey',
        }),
    },
    methods: {
        ...mapActions('UniqueKeyModule', {
            setUniqueKey: 'setUniqueKey',
        }),

        checkKey() {
            this.key=''
            this.$emit('check-key')
        },
        focus(){
            this.$nextTick(() => this.$refs['auth-field'].focus())
        }
    },
    watch: {
        /**
         * @description
         */
        uniqueKey: function(newVal, oldVal){
            console.log('KEY', this.key)
            this.key = newVal
        },
    },
    components: {},
    mixins: [],
    filters: {},
    // Lifecycle Methods
    //
    // beforeCreate: function(){...},
    // created: function(){...},
    // beforeMount: function(){...},
    mounted: function(){
        this.key=''
        this.$nextTick(() => this.$refs['auth-field'].focus())
    },
    // beforeUpdate: function(){...},
    // updated: function(){...},
    // beforeDestroy: function(){...},
    // destroyed: function(){...},
    //
    // End Lifecycle Methods
}
</script>

<style lang="scss">
    
</style>